export default __webpack_public_path__ + "static/media/big-cartel-coloured-logo.bccd1967.jpeg";